import { useEffect, useState } from "react"
import { Action, PanelLoader } from "../../../../../features/ui"
import { BookmarkButton } from "../../../../../features/bookmarks"
import { PaymentOrderList } from "./paymentOrderList"
import { useNavigate } from "react-router-dom"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { PaymentOrder, Ticket } from "../../../state/types"
import { usePaymentOrderLoaders } from "../../../loaders/paymentOrderLoaders"
import { useTicketLoaders } from "../../../loaders/ticketLoaders"
import { Supplier, useSupplierLoaders } from "../../../../purchases"
import { dedupe } from "../../../../../utils/listUtils"

export const PaymentOrderListLoader = () => {
    const [paymentOrders, setPaymentOrders] = useState<PaymentOrder[]>([])
    const [suppliers, setSuppliers] = useState<Supplier[]>([])
    const [ticketsMap, setTicketsMap] = useState<Map<string, Ticket[]>>(new Map())
    const [supplierMap, setSupplierMap] = useState<Map<string, string>>(new Map())
    const [ready, setReady] = useState(false)

    const navigate = useNavigate()
    const { getRoutePath } = useRoutesHooks()

    const paymentOrderLoaders = usePaymentOrderLoaders()
    const supplierLoaders = useSupplierLoaders()
    const ticketLoaders = useTicketLoaders()

    const populate = async () => {
        const { loadAllPaymentOrders } = paymentOrderLoaders()
        const loadedPaymentOrders = await loadAllPaymentOrders(true)
        setPaymentOrders(loadedPaymentOrders)
        const ticketIds = loadedPaymentOrders.map(paymentOrder => paymentOrder.ticketItems.map(ticketItem => ticketItem.ticketId)).flat()
        const { loadTickets, loadParents } = ticketLoaders()
        const tickets = await loadTickets(ticketIds)
        const parents = await loadParents(ticketIds)
        const supplierIds = dedupe(parents.filter(parent => !!parent.supplierId).map(parent => parent.supplierId!))
        const { loadSuppliers } = supplierLoaders()
        const loadedSuppliers = await loadSuppliers(supplierIds)
        setSuppliers(loadedSuppliers)
        const paymentOrderTicketsMap = new Map<string, Ticket[]>()
        const paymentOrderSupplierMap = new Map<string, string>()
        loadedPaymentOrders.forEach(paymentOrder => {
            const paymentOrderTickets = tickets.filter(ticket => paymentOrder.ticketItems.map(ticketItem => ticketItem.ticketId).includes(ticket.id))
            paymentOrderTicketsMap.set(paymentOrder.id, paymentOrderTickets)
            const paymentOrderOperation = parents.find(parent => paymentOrderTickets.map(paymentOrderTicket => paymentOrderTicket.parentId).includes(parent.id))
            paymentOrderOperation?.supplierId && paymentOrderSupplierMap.set(paymentOrder.id, paymentOrderOperation.supplierId)
        })
        setTicketsMap(paymentOrderTicketsMap)
        setSupplierMap(paymentOrderSupplierMap)
    }

    useEffect(() => {
        populate().then(() => setReady(true))
    }, [])

    const onGoToPendingPayments = () => {
        navigate(getRoutePath(RoutePath.PENDING_PAYMENTS))
    }

    const headerActions: Action[] = [
        { label: 'Pagos Pendientes', kind: 'tertiary', onClick: onGoToPendingPayments }
    ]

    return (
        <PanelLoader
            title="Órdenes de Pago"
            actions={headerActions}
            ready={ready}
            wide
            titleRight={<BookmarkButton routePath={RoutePath.PAYMENT_ORDERS} />}
        >
            <PaymentOrderList
                paymentOrders={paymentOrders}
                suppliers={suppliers}
                ticketsMap={ticketsMap}
                supplierMap={supplierMap}
            />
        </PanelLoader>
    )
}
